import store from '@/store'

let langTextMixin = {
    data() { 
        return {
            ltLoaded: false
        }
    },
    created: function () {
        store.dispatch('getLangTexts')
    },
    methods: {
        langTextTpl: function(skey, plObj) {
            const compiled = _.template(this.langText(skey, false));
            try {
                return compiled(plObj);
            } catch {
                return this.langText(skey, true);
            }
        }
    },
    computed: {
        langText: function() {
            return function(ltKey, placeholder) {
                if (store.state.langTextCode === 200) {
                    this.ltLoaded = true;
                    const res = _.get(store.state.langTexts, ltKey, ( placeholder ? '{ ' + ltKey + ' }' : ''));
                    return _.isEmpty(res) && placeholder ? '{ ' + ltKey + ' }' : res;             
                } else if(store.state.langTextCode !== null) {
                    return placeholder ? '{ ' + ltKey + ' }' : ''
                } else {
                    return '';
                }
            };
        }
    }
  }
  export default langTextMixin;